import React from "react";
import { QRCodeSVG } from "qrcode.react";

interface Props {
  lineAddFriendUrl: string;
  lineLoading: boolean;
  lineStatusChecking: boolean;
  startLineLogin: () => void;
  refreshFriendStatus: () => void;
  t: (key: string) => string;
}

export default function LineTroubleModal({ lineAddFriendUrl, lineLoading, lineStatusChecking, startLineLogin, refreshFriendStatus, t }: Props) {
  return (
    <div className="modal fade qr-modal" id="lineTroubleModal" tabIndex={-1} aria-labelledby="lineTroubleModalLabel" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header d-flex justify-content-between align-items-center p-3 border-bottom">
            <h5 className="modal-title m-0" id="lineTroubleModalLabel">{t("line_help_title")}</h5>
            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close">&times;</button>
          </div>
          <div className="modal-body p-3 text-center">
            <div className="border-bottom pb-3 mb-3">
              <h6 className="text-start mb-2">{t("line_help_step1_title")}</h6>
              <p className="text-start text-muted mb-2">{t("line_help_step1_desc")}</p>
              <button className="btn btn-success w-100" type="button" onClick={startLineLogin} disabled={lineLoading}>{t("line_help_login_btn")}</button>
            </div>
            <div className="mb-3">
              <h6 className="text-start mb-2">{t("line_help_step2_title")}</h6>
              <p className="line-trouble-hint text-start text-muted mb-3">{t("line_help_step2_desc")}</p>
              <div className="line-qr-box d-flex flex-column align-items-center mb-2">
                <div className="line-qr-code p-2 border rounded bg-white mb-2"><QRCodeSVG value={lineAddFriendUrl} size={156} /></div>
                <a className="btn btn-outline-success w-100 mb-2" href={lineAddFriendUrl} target="_blank" rel="noreferrer">{t("line_help_add_friend_link")}</a>
                <small className="line-friend-url text-muted text-break">{lineAddFriendUrl}</small>
              </div>
            </div>
            <button className="btn btn-outline-primary w-100 mb-3" type="button" onClick={refreshFriendStatus} disabled={lineLoading || lineStatusChecking}>{t("line_help_recheck_btn")}</button>
            <div className="line-still-not-working text-muted p-2 bg-light rounded">{t("line_help_still_not_working")}</div>
          </div>
          <div className="modal-footer p-2 border-top"><button type="button" className="btn btn-secondary w-100" data-bs-dismiss="modal">{t("line_help_close_btn")}</button></div>
        </div>
      </div>
    </div>
  );
}
